module.exports = __webpack_public_path__ + "stylesheets/wave-section-how-work_a12bd1ee9c0aa74bfff55c70f3d4cb95.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/wave/wave-section-how-work.less
// module id = xU9L
// module chunks = 151